import { io, Socket } from 'socket.io-client';

let socket: Socket | null = null;

export function getSocket(): Socket {
  if (socket?.connected) return socket;

  const base = import.meta.env.VITE_API_URL ?? '';

  socket = io(`${base}/ws`, {
    withCredentials: true,        // envía la cookie httpOnly anik_token
    reconnectionAttempts: 10,
    reconnectionDelay: 2000,
    transports: ['websocket', 'polling'],
  });

  return socket;
}

export function disconnectSocket() {
  socket?.disconnect();
  socket = null;
}
